import {
    useEffect,
    useRef
} from "react";

interface FantasyModalBackGuardOptions {
    isOpen: boolean;
    onDismiss: () => void;
    priority?: number;
    canDismiss?: boolean;
}

export function useFantasyModalBackGuard({
    isOpen,
    onDismiss,
    priority = 10000,
    canDismiss = true
}: FantasyModalBackGuardOptions): void {
    const onDismissRef = useRef(onDismiss);
    const canDismissRef = useRef(canDismiss);

    useEffect(
        function () {
            onDismissRef.current = onDismiss;
        },
        [onDismiss]
    );

    useEffect(
        function () {
            canDismissRef.current = canDismiss;
        },
        [canDismiss]
    );

    useEffect(
        function () {
            if (!isOpen) {
                return;
            }

            function handleIonBackButton(
                nativeEvent: Event
            ): void {
                const event = nativeEvent as CustomEvent<{
                    register: (
                        priority: number,
                        handler: () => void
                    ) => void;
                }>;

                event.detail.register(
                    priority,
                    function (): void {
                        if (!canDismissRef.current) {
                            return;
                        }

                        onDismissRef.current();
                    }
                );
            }

            document.addEventListener(
                "ionBackButton",
                handleIonBackButton
            );

            return function (): void {
                document.removeEventListener(
                    "ionBackButton",
                    handleIonBackButton
                );
            };
        },
        [
            isOpen,
            priority
        ]
    );
}
